import Permalink from 'ol-ext/control/Permalink'
import { updateDateFilter, filterPlaces, filterTravels } from './filter'
import { loadLanguageOL } from './translations';

export const DEFAULT_START = '1485-11-01';
export const DEFAULT_END = '1548-10-27';

let startDate;
let endDate;

export const permalinkFeature = new Permalink({
  visible: false,
});

export function applyOnStartDateFilter() {
  triggerFilters(startDate, endDate);
}

export function setDate(start, end) {
  $('#daterange').data('daterangepicker').setStartDate(start);
  $('#daterange').data('daterangepicker').setEndDate(end);
}

function setPermalink(start, end) {
  permalinkFeature.setUrlParam('startDate', start);
  permalinkFeature.setUrlParam('endDate', end);
}

function triggerFilters(start, end) {
  updateDateFilter(start, end);
  filterPlaces.doSelect({});
  filterTravels.doSelect({});
}

export function triggerDateChange(start, end) {
  triggerFilters(start, end);
  setPermalink(start, end);

  if (start != DEFAULT_START || end != DEFAULT_END) {
    $('#daterange').addClass('calendarActive');
    $('#calendar').addClass('calendarActive');
    $('.bi-calendar-week').addClass('calendarActive');
  } else {
    $('#daterange').removeClass('calendarActive');
    $('#calendar').removeClass('calendarActive');
    $('.bi-calendar-week').removeClass('calendarActive');
  }
}

export function datepickerSetup(lang) {
  $('#daterange').daterangepicker({

    "showDropdowns": true,
    "linkedCalendars": false,
    "locale": {
      "format": "YYYY-MM-DD",
      "separator": loadLanguageOL(lang, 'datepickerSeparator'),
      "applyLabel": loadLanguageOL(lang, 'datepickerApply'),
      "cancelLabel": loadLanguageOL(lang, 'datepickerReset'),
      "fromLabel": loadLanguageOL(lang, 'datepickerFrom'),
      "toLabel": loadLanguageOL(lang, 'datepickerTo'),
      "customRangeLabel": "Custom",
      "weekLabel": "W",
      "daysOfWeek": [
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      ],
      "monthNames": [
        loadLanguageOL(lang, 'datepickerJanuary'),
        loadLanguageOL(lang, 'datepickerFebruary'),
        loadLanguageOL(lang, 'datepickerMarch'),
        loadLanguageOL(lang, 'datepickerApril'),
        loadLanguageOL(lang, 'datepickerMay'),
        loadLanguageOL(lang, 'datepickerJune'),
        loadLanguageOL(lang, 'datepickerJuly'),
        loadLanguageOL(lang, 'datepickerAugust'),
        loadLanguageOL(lang, 'datepickerSeptember'),
        loadLanguageOL(lang, 'datepickerOctober'),
        loadLanguageOL(lang, 'datepickerNovember'),
        loadLanguageOL(lang, 'datepickerDecember')
      ],
      "firstDay": 5
    },
    "minDate": DEFAULT_START,
    "maxDate": DEFAULT_END,
    "drops": "auto",
  }, function (start, end, label) {
    startDate = start.format('YYYY-MM-DD');
    endDate = end.format('YYYY-MM-DD');

    triggerDateChange(startDate, endDate);
  });
}

datepickerSetup('en');

$(function () {
  if (permalinkFeature.getUrlParam('startDate')) {
    startDate = permalinkFeature.getUrlParam('startDate');
    endDate = permalinkFeature.getUrlParam('endDate');
  } else {
    startDate = DEFAULT_START;
    endDate = DEFAULT_END;
  }

  setDate(startDate, endDate);
  triggerDateChange(startDate, endDate);

  if (startDate != DEFAULT_START || endDate != DEFAULT_END) {
    $('#daterange').addClass('calendarActive');
    $('#calendar').addClass('calendarActive');
    $('.bi-calendar-week').addClass('calendarActive');

  }

});

$('#daterange').on('cancel.daterangepicker', function (ev, picker) {
  setDate(DEFAULT_START, DEFAULT_END);
  picker.show();
});

$('#daterange').on('apply.daterangepicker', function (ev, picker) {
  startDate = picker.startDate.format('YYYY-MM-DD');
  endDate = picker.endDate.format('YYYY-MM-DD');

  triggerDateChange(startDate, endDate);
});

